export const SET_FETCH_DEFAULTS = 'SET_FETCH_DEFAULTS';
export const SET_FETCH_STATUS = 'SET_FETCH_STATUS';
export const REQUEST_STATE = 'REQUEST_STATE';
export const SET_FETCH_LOADING = 'SET_FETCH_LOADING';
export const LOAD_IO_STATE_BY_BOOK_ID = 'LOAD_IO_STATE_BY_BOOK_ID';
export const IMAGES_LOADING = 'IMAGES_LOADING';
export const AUTOFILL_FINISHED = 'AUTOFILL_FINISHED';
export const CONVERT_FINISHED = 'CONVERT_FINISHED';




// WEBPACK FOOTER //
// ./src/redux/action-types/entities/io.js